export const COPY_FORM_ELEMENTS = 'fulcrum/containers/ProductPgmOverview/COPY_FORM_ELEMENTS'

const RiskEnum = {
  ALLOWED: 'Allowed',
  RISK: 'Risk',
}

export const Risk = Object.freeze(RiskEnum)
